export default __webpack_public_path__ + "static/media/Logo.3b78f3df.svg";